import routerOptions0 from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/node_modules/.pnpm/nuxt@4.1.2_@parcel+watcher@2.5.1_@types+node@18.19.127_@vue+compiler-sfc@3.5.22_db0@0.3.2_esl_pywiuah62xewji35ldldycfhxe/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  linkPrefetchedClass: "nuxt-link-prefetched",
  linkActiveClass: "nuxt-link-active",
  linkExactActiveClass: "nuxt-link-exact-active",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}